<mat-chip-grid #chipGrid>
    <mat-chip *ngFor="let item of tagsToShow"
              #chipTooltip="matTooltip"
              [matTooltip]="item.displayText"
              removable
              [disabled]="disabled"
              (removed)="remove(item)"
              (click)="search(item)"
              [disabled]="disabled">
        {{item.displayText}}
        <button matChipRemove
                [attr.aria-label]="'remove ' + item"
                [disabled]="disabled">
            <mat-icon>close</mat-icon>
        </button>
    </mat-chip>
    <mat-chip *ngIf="maxItemsToShow > 0 && value?.length > maxItemsToShow"
              #tooltip="matTooltip"
              [matTooltip]="tagsAsTooltip"
              [disabled]="disabled">
        {{ '+ ' + (value?.length - maxItemsToShow) + ' more' }}
    </mat-chip>
    <mat-chip [class.st-tags-autocomplete-valid]="required && value?.length == 0"
              [class.st-tags-autocomplete-required]="required"
              [disabled]="disabled"
              [matMenuTriggerFor]="listDropDownMenu"
              (menuClosed)="valueChanged()"
              (menuOpened)="onMenuOpened()"
              class="st-tags-autocomplete-button">
        <mat-icon matChipAvatar>
            add
        </mat-icon>
        <span class="st-tags-autocomplete-label">{{label}}</span>
    </mat-chip>
</mat-chip-grid>

<mat-menu #listDropDownMenu="matMenu"
          class="st-tags-autocomplete-menu">
    <form click-stop-propagation [dir]="dir">
        <mat-form-field subscriptSizing="dynamic"
                        appearance="fill">
            <input type="text"
                   #searchBox
                   matInput
                   [matChipInputFor]="chipGrid"
                   [placeholder]="languageSettings.PSTWebAddTagLabel"
                   [formControl]="tagsFilter"
                   (matChipInputTokenEnd)="add($event)">
        </mat-form-field>
        <mat-selection-list [ngModel]="value"
                            click-stop-propagation
                            hideSingleSelectionIndicator
                            (selectionChange)="selected($event)"
                            [multiple]="false">
            <mat-list-option *ngFor="let tag of suggestions | async"
                             [value]="tag">
                <div matListItemTitle>{{tag.displayText}}</div>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
